import config from '../services/config';

const postMessageToLitten = (action: string, values?: object) => {
  window.parent.postMessage({ id: 'lit', action, values }, config.urls.LITTEN);
};

export default postMessageToLitten;
